
export const TIPO_CAMPO_AVALIACAO_V2 = {
  Texto: 1,
  Inteiro: 2,
  Decimal: 3,
  Radio: 4,
  Checkbox: 5,
  Upload: 6,
  Cnpj: 7,
} as const;

export type TipoCampoAvaliacaoV2Id =
  (typeof TIPO_CAMPO_AVALIACAO_V2)[keyof typeof TIPO_CAMPO_AVALIACAO_V2];
